import { createContext, useContext } from "react";

export const ProductAddingModalContext = createContext([]);
export const useProductAddingModalContext = () =>
  useContext(ProductAddingModalContext);
export const ProductAddingModalContextProvider =
  ProductAddingModalContext.Provider;
